var _defs, _path, _circle, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClientMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.495,
    height: 21.97,
    viewBox: "0 0 19.495 21.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;opacity:0.58;}.b{clip-path:url(#a);}.c{fill:#a6bdc5;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M296.394,389.472a1.119,1.119,0,0,0-1.442,0l-3.128,2.5a2.157,2.157,0,0,1-1.354.474h-4a.541.541,0,0,1-.541-.541h0a.541.541,0,0,1,.541-.541h2.65a1.129,1.129,0,0,0,1.127-.9,1.083,1.083,0,0,0-1.073-1.266h-5.413a3.976,3.976,0,0,0-2.509.891l-1.574,1.275H277.8a.541.541,0,0,0-.541.541v3.249a.541.541,0,0,0,.538.544h12.079a2.171,2.171,0,0,0,1.354-.474l5.117-4.1a1.083,1.083,0,0,0,.045-1.655Z",
    transform: "translate(-277.259 -373.729)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(4.001)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M277.8,389.364h1.167l1.025-.83a6,6,0,0,1,3.766-1.336h5.414a3.184,3.184,0,0,1,2.36,1.092,3.092,3.092,0,0,1,.538.923l.325.515h.864v-2c0-2.66-5.33-4-8-4s-8,1.34-8,4v1.7a2.54,2.54,0,0,1,.541-.064Z",
    transform: "translate(-277.259 -373.729)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientMenu);
export default __webpack_public_path__ + "static/media/client_menu.2a6981057217188cea069ad4289de836.svg";
export { ForwardRef as ReactComponent };